import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import { BaseinfoRes, type BaseinfoReq } from '@/types/api/hall/baseinfo.d';

export interface Banlance {
  balance: string;
  code?: string;
  // icon: string;
  bonus?: string;
}

export const getBaseInfo = ({ params }: { params: BaseinfoReq; }) =>
  get<BaseinfoRes>('/hall/v1/baseinfo', {
    params,
  });

export const useGetBaseInfo = createApiQuery(getBaseInfo, () => ['base-info']);